import * as angular from 'angular';
import { HttpService } from '../../../../../app.common/modules/api/http.service';
import { RetailerService } from '../../../api/retailer.service';
import { IPagingResult } from '../../../model/IPagingResult.model';
import { IVendor } from './models/IVendor';
import { IVendorListItem } from './models/IVendorListItem';
import { IVendorSearchFilter } from './models/IVendorSearchFilter';
export class VendorsMockService {
    public static $inject = ['http', 'retailerService'];
    private data: IVendorListItem[] = [
        {
            ID: 1,
            FirstName: 'Name 1',
            LastName: 'Surname',
            ImageID: null,
            UserName: 'Name 1 Surname',
            Street: 'street 1',
            PlacesID: [2],
            places: [{
                id: 2,
                info: 'John\'s place, London, St.James\'s Park',
                isActive: true,
                isBanned: false
            }],
        },
        {
            ID: 2,
            FirstName: 'Name 2',
            LastName: 'Surname',
            ImageID: null,
            UserName: 'Name 2 Surname',
            Street: 'street 2',
            PlacesID: [2],
            places: [{
                id: 2,
                info: 'John\'s place, London, St.James\'s Park',
                isActive: true,
                isBanned: false
            }],
        },
        {
            ID: 3,
            FirstName: 'Name 3',
            LastName: 'Surname',
            ImageID: null,
            UserName: 'Name 3 Surname',
            Street: 'street 3',
            PlacesID: [2],
            places: [{
                id: 2,
                info: 'John\'s place, London, St.James\'s Park',
                isActive: true,
                isBanned: false
            }],
        }];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService) { }

    public getVendors(filter: IVendorSearchFilter) {
        const vendors: IPagingResult<IVendorListItem> = {
            Items: [...this.data],
            Total: 3
        };

        return Promise.resolve(vendors);
    }

    public getVendor(vendorID: number) {
        const vendor: IVendor = {
            ID: 1,
            FirstName: 'Name',
            LastName: 'Surname',
            UserName: 'NameSurname',
            ImageID: null,
            Age: 22,
            Street: 'Some street',
            Password: '12345678',
            Description: 'DescriptionTextDescriptionTextDescriptionText',
            ShortDescription: 'DescriptionText',
            PlacesID: [1],
            Latitude: 51.50155141535449,
            Longitude: -0.13463923862309457,
            // Latitude: null,
            // Longitude: null,
            Interviewer: {
                InterviewerName: 'Author name',
                InterviewerImg: 'Some img'
            }
        };

        return Promise.resolve(vendor);
    }

    public createOrUpdateVendor(vendor: IVendor, vendorID?: number) {
        if (vendorID == null) {
            return Promise.resolve();
            // return this.http.post<number>(this.retailerService.getVendors(), vendor);
        } else {
            return Promise.resolve();
            // return this.http.put(this.retailerService.getVendor(vendorID), vendor);
        }
    }

    public archiveVendor(vendorID: number) {
        // return this.http.put(this.retailerService.archiveVendor(vendorID), null);
    }

    public restoreVendor(vendorID: number) {
        // return this.http.put(this.retailerService.restoreVendors(vendorID), null);
    }

    public saveVendorImageUrl() {
        // return this.retailerService.createVendorImage();
    }

    public getVendorImageUrl(imageID: number): string {
        return;
    }

}

angular
    .module('naut')
    .service('vendorsMockService', VendorsMockService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/components/vendors/vendors-mock.service.ts